import { z } from "zod";

/**
 * PriceTrendNodeSchema - Content Schema for Price Trend Analysis Node
 *
 * PriceTrend nodes contain technical analysis with key price levels.
 *
 * Field naming convention:
 * - symbol: Stock ticker symbol
 * - trend: BULLISH | BEARISH | NEUTRAL
 * - support: Support price level
 * - resistance: Resistance price level
 * - target: Target price
 * - stopLoss: Stop loss price (optional)
 * - notes: Analysis notes (optional)
 * - chartUrl: Chart image URL (optional)
 */
export const PriceTrendNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("price-trend"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  symbol: z.string().min(1).max(20),
  trend: z.enum(["BULLISH", "BEARISH", "NEUTRAL"]),
  support: z.number(),
  resistance: z.number(),
  target: z.number(),
  stopLoss: z.number().optional(),
  notes: z.string().optional(),
  chartUrl: z.string().optional(),
}).strict();

export type PriceTrendNode = z.infer<typeof PriceTrendNodeSchema>;
